(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slim-weight-loss-plan"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', function () {
    const content = this.nextElementSibling;
    const item = this.closest('.accordion-item');
    const isOpen = content.style.display === 'block';

    // Close all
    document.querySelectorAll('.accordion-content').forEach(c => c.style.display = 'none');
    document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));

    // Open clicked
    if (!isOpen) {
      content.style.display = 'block';
      item.classList.add('active');
    }
  });
});

document.querySelectorAll('.tab-header').forEach(header => {
  header.addEventListener('click', function () {
    const tabId = this.dataset.tab;

    // Remove active from all tab headers and tab contents
    document.querySelectorAll('.tab-header').forEach(tab => tab.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));

    // Add active to clicked tab header and corresponding content
    this.classList.add('active');
    const activeContent = document.querySelector('.tab-' + tabId);
    if (activeContent) activeContent.classList.add('active');
  });
});

// Default first tab active on desktop
if (window.innerWidth >= 768) {
  const firstTabHeader = document.querySelector('.tab-header');
  const firstTabContent = document.querySelector('.tab-content');

  if (firstTabHeader) firstTabHeader.classList.add('active');
  if (firstTabContent) firstTabContent.classList.add('active');
}

  } catch(e) { console.error(e); }
})();
})();
